export { Caption } from './caption';
export type { CaptionProps } from './caption';
